import { render, staticRenderFns } from "./CustomerPatchUpload.vue?vue&type=template&id=0408c33e&"
import script from "./CustomerPatchUpload.vue?vue&type=script&lang=js&"
export * from "./CustomerPatchUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports